import { useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import TabelaMatrizRiscoLayout, {
  BadgeMatrizRisco,
  CelulaMatrizRisco,
  CodigosMatrizRisco,
} from './TabelaMatrizRiscoLayout';
import {
  aplicarFiltroQuadrante,
  obterAvaliacoesQuadrante,
  obterCodigosItens,
  quadranteContemSelecionados,
} from './tabela.utils';
import { criarRenderCelulaGrau, VISAO_MATRIZ } from './VisaoGrauMatrizRisco';

const TabelaMatrizRisco = ({
  matrizFarol,
  riscoAvaliacoesOriginal,
  idsSelecionados,
  setFilter,
  setPositionMouse,
  positionMouse,
  positionInerente,
  inerente,
  header,
  apenasMaiorQueZero,
  exibirCodigoItem,
  isWidget,
  heightBase,
  visao = VISAO_MATRIZ.QUANTIDADE,
  setFilterGrau,
}) => {
  const { terms: resources } = useAuth();
  const [grauEmFoco, setGrauEmFoco] = useState(null);
  if (!matrizFarol) return null;

  const {
    severidades = [],
    probabilidades = [],
    itens = [],
    riscoAvaliacoes = [],
    inverter,
  } = matrizFarol;
  const linhas = (inverter ? severidades : probabilidades) || [];
  const colunas = (inverter ? probabilidades : severidades) || [];

  const obterItem = (linha, coluna) => {
    const severidade = inverter ? linha : coluna;
    const probabilidade = inverter ? coluna : linha;
    return itens.find(
      (item) =>
        item.severidade.id === severidade.id &&
        item.probabilidade.id === probabilidade.id
    );
  };

  const renderCelulaGrau =
    visao === VISAO_MATRIZ.GRAU_RISCO &&
    criarRenderCelulaGrau({
      linhas,
      colunas,
      obterQuadrante: (linha, coluna) => {
        const item = obterItem(linha, coluna);
        return item
          ? {
              severidade: item.severidade,
              probabilidade: item.probabilidade,
              cor: item.cor,
              chaveGrau: item.grauRisco?.id,
            }
          : null;
      },
      riscoAvaliacoes,
      riscoAvaliacoesOriginal,
      idsSelecionados,
      inerente,
      setFilterGrau,
      setPositionMouse,
      grauEmFoco,
      setGrauEmFoco,
    });

  return (
    <TabelaMatrizRiscoLayout
      header={header}
      linhas={linhas}
      colunas={colunas}
      labelLinhas={inverter ? resources.severidade : resources.probabilidade}
      labelColunas={inverter ? resources.probabilidade : resources.severidade}
      isWidget={isWidget}
      heightBase={heightBase}
      positionMouse={positionMouse}
      positionInerente={positionInerente}
      inerente={inerente}
      setPositionMouse={setPositionMouse}
      renderCelula={(linha, coluna, indexColuna) => {
        if (renderCelulaGrau)
          return renderCelulaGrau(linha, coluna, indexColuna);
        const severidade = inverter ? linha : coluna;
        const probabilidade = inverter ? coluna : linha;
        const item = obterItem(linha, coluna);
        const key = severidade.id + '-' + probabilidade.id;
        if (!item) {
          return <td key={key} className="tw:border tw:border-border tw:p-0" />;
        }

        const avaliacoes = obterAvaliacoesQuadrante(
          riscoAvaliacoes,
          severidade,
          probabilidade,
          inerente
        );
        const destacada = quadranteContemSelecionados(
          avaliacoes,
          idsSelecionados
        );
        const codigos = obterCodigosItens(avaliacoes);

        return (
          <CelulaMatrizRisco
            key={key}
            cor={item.cor}
            selecionada={idsSelecionados?.length > 0 && destacada}
            desbotada={!destacada}
            label={linha.nome + ' / ' + coluna.nome}
            onClick={() =>
              aplicarFiltroQuadrante({
                avaliacoes: riscoAvaliacoes,
                riscoAvaliacoesOriginal,
                idsSelecionados,
                severidade,
                probabilidade,
                inerente,
                setFilter,
              })
            }
            onMouseEnter={() => setPositionMouse?.(indexColuna, inerente)}
            onMouseLeave={() => setPositionMouse?.(-1)}
          >
            {(!apenasMaiorQueZero || avaliacoes.length > 0) &&
              (exibirCodigoItem ? (
                <CodigosMatrizRisco title={codigos}>
                  {codigos}
                </CodigosMatrizRisco>
              ) : (
                <BadgeMatrizRisco>{avaliacoes.length}</BadgeMatrizRisco>
              ))}
          </CelulaMatrizRisco>
        );
      }}
    />
  );
};

export default TabelaMatrizRisco;
